module.exports = __webpack_public_path__ + "img/icon_arrow.fc75f7c8.svg";